/* eslint-disable import/prefer-default-export,object-curly-newline */
/* global G */

/**
 * Returns the parts of the URL to be used to generate the notes URL. For that, it makes use
 * of the current model's api values, that can be overridden with the optional `api` object.
 *
 * @param {Gaia.Web.Application} app    the Platform Web Application
 * @param {Object} [props]              an optional object, in case we want to override the current
 *                                      model values to form the URL
 * @returns {{ref, host, api, version}} the URL parts
 */
const getUrlParts = (app, props = {}) => {
  const appState = app[G.SESSION][G.STATE]
  const host = appState[G.HTTP]
  const model = appState[G.MODULE][G.MODEL]
  const version = props.version || model[G.PROPS].version
  return { host, version, key: props.key }
}

/**
 * Returns the notes url.
 *
 * @param {Gaia.Web.Application} app    the Platform Web Application
 * @param {Object} [props]
 * @returns {string}
 */
export const getUrl = (app, props) => {
  const { host, version, key = '' } = getUrlParts(app, props)
  return `${host}/api/v${version}/note/${key}`
}

/**
 * Disables the loader middleware
 *
 * @param {Function} loader   loader middleware
 * @param {object} middleware other middlewares
 * @returns {unknown[]}
 */
export const noLoaderMiddleware = ({ loader, ...middleware }) => Object.values(middleware)
